import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { getAlarmTypesAction } from "../actions/get-alarm-types.actions";
import { customerPortal } from "@vilocnv/allsetra-core";

type AlarmState = customerPortal.alarms.AlarmState;

const getAlarmTypesCases = (builder: ActionReducerMapBuilder<AlarmState>) => {
  builder
    .addCase(getAlarmTypesAction.pending, (state) => {
      state.isLoadingAlarmTypes = true;
    })
    .addCase(getAlarmTypesAction.fulfilled, (state, { payload }) => {
      state.alarmsTypes = payload;
      state.isLoadingAlarmTypes = false;
    })
    .addCase(getAlarmTypesAction.rejected, (state) => {
      state.isLoadingAlarmTypes = false;
    });
};

export default getAlarmTypesCases;
